import React from 'react';
import {Col, Row} from 'react-bootstrap';

const ContactPage = () => {
    return (
        <>
            <h4 className="mb-4">Kontakt</h4>

            <Row className="mb-3">
                <Col xs={12} md={4}><strong>Adresa:</strong></Col>
                <Col xs={12} md={8}>Rovenská 668/2, Senica</Col>
            </Row>

            <Row className="mb-3">
                <Col xs={12} md={4}><strong>Email:</strong></Col>
                <Col xs={12} md={8}>info@formafitness.sk</Col>
            </Row>

            <Row className="mb-3">
                <Col xs={12} md={4}><strong>Mobil:</strong></Col>
                <Col xs={12} md={8}>0917 461 735</Col>
            </Row>

            <Row className="mb-3">
                <Col xs={12} md={4}><strong>Otváracie hodiny:</strong></Col>
                <Col xs={12} md={8}>Pondelok – Nedeľa: podľa objednávky</Col>
            </Row>
        </>
    );
}

export default ContactPage;